import { getPublicMenuBaseUrl } from '@/lib/restaurantPublicUrl'

/** @typedef {'pharmacy' | 'shop' | 'lab'} OtherPublicEntityKind */

/** صيدلية / محل / معمل فقط — المطعم والسوق يستخدمان restaurantPublicUrl.js كما كان */
export const OTHER_PUBLIC_ENTITY_CONFIGS = {
  pharmacy: {
    pathSegment: 'p',
    labelAr: 'صيدلية',
    qrHeader: 'QR الصيدلية',
    qrHint: 'امسح الكود أو افتح الرابط لعرض بيانات الصيدلية وصور المنيو.',
    footerTitleSuffix: 'Pharmacy',
    pageTitleSuffix: 'صيدلية',
    notFoundMessage: 'الصيدلية غير موجودة'
  },
  shop: {
    pathSegment: 'shop',
    labelAr: 'محل',
    qrHeader: 'QR المحل',
    qrHint: 'امسح الكود أو افتح الرابط لعرض بيانات المحل وطرق التواصل.',
    footerTitleSuffix: 'Shop',
    pageTitleSuffix: 'محل',
    notFoundMessage: 'المحل غير موجود'
  },
  lab: {
    pathSegment: 'lab',
    labelAr: 'معمل',
    qrHeader: 'QR المعمل',
    qrHint: 'امسح الكود أو افتح الرابط لعرض بيانات المعمل وطرق التواصل.',
    footerTitleSuffix: 'Lab',
    pageTitleSuffix: 'معمل',
    notFoundMessage: 'المعمل غير موجود'
  }
}

export const OTHER_PUBLIC_ENTITY_PATH_PREFIXES = Object.values(OTHER_PUBLIC_ENTITY_CONFIGS).map(
  (c) => `/${c.pathSegment}/`
)

export function getOtherPublicEntityConfig(kind) {
  return OTHER_PUBLIC_ENTITY_CONFIGS[kind] || OTHER_PUBLIC_ENTITY_CONFIGS.pharmacy
}

export function getEntityPublicProfileUrl(kind, entityId) {
  const id = String(entityId || '').trim()
  if (!id) return ''

  const cfg = getOtherPublicEntityConfig(kind)
  const base = getPublicMenuBaseUrl()
  const path = `/${cfg.pathSegment}/${encodeURIComponent(id)}`
  if (!base) return path
  return `${base}${path}`
}

export function slugifyEntityFilename(name, fallbackId, kind = 'pharmacy') {
  const cfg = getOtherPublicEntityConfig(kind)
  const raw = String(name || fallbackId || cfg.labelAr)
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\u0600-\u06FF-]+/g, '')
  return raw || String(fallbackId || cfg.pathSegment)
}
